import PropTypes from 'prop-types'

import AtomIcon from '@s-ui/react-atom-icon'
import {useSuiContext} from '@s-ui/react-context'
import MoleculePagination, {
  moleculePaginationDesigns,
  moleculePaginationShapes,
  moleculePaginationSizes
} from '@s-ui/react-molecule-pagination'
import IconAngleLeft from '@adv-mt/mt-svg-icons/lib/AngleLeft'
import IconAngleRight from '@adv-mt/mt-svg-icons/lib/AngleRight'

const buttonDesign = moleculePaginationDesigns.OUTLINE

/* DEFAULT_NUM_PAGES_TO_SHOW comes defined by UX reqs for motor */
const DEFAULT_NUM_PAGES_TO_SHOW = 3
const DEFAULT_PAGE_NUMBER_PLACEHOLDER = '%{pageNumber}'

const prevButtonIcon = () => (
  <AtomIcon>
    <IconAngleLeft svgClass="mt-ListPagination-icon" />
  </AtomIcon>
)
const nextButtonIcon = () => (
  <AtomIcon>
    <IconAngleRight svgClass="mt-ListPagination-icon" />
  </AtomIcon>
)

// eslint-disable-next-line
const Link = ({href, children, ...props}) => {
  return (
    <a {...props} href={href}>
      {children}
    </a>
  )
}

const defaultCreateUrl = ({pageNumber, urlPattern}) => urlPattern.replace(DEFAULT_PAGE_NUMBER_PLACEHOLDER, pageNumber)

const ListPagination = ({
  createUrl = defaultCreateUrl,
  currentPage = 1,
  linkFactory = Link,
  onClick = () => {},
  showPages = DEFAULT_NUM_PAGES_TO_SHOW,
  totalPages = 1,
  urlPattern = '#'
}) => {
  const {i18n} = useSuiContext()
  const buttonColor = 'primary'

  const handleOnClick = (e, {page}) => {
    onClick({page})
  }

  return (
    <div className="mt-ListPagination">
      <MoleculePagination
        createUrl={createUrl}
        linkFactory={linkFactory}
        nextButtonColor={buttonColor}
        nextButtonDesign={buttonDesign}
        nextButtonIcon={nextButtonIcon}
        nextButtonText={null}
        nonSelectedPageButtonColor={buttonColor}
        nonSelectedPageButtonDesign={buttonDesign}
        onSelectNext={handleOnClick}
        onSelectPage={handleOnClick}
        onSelectPrev={handleOnClick}
        page={currentPage}
        prevButtonColor={buttonColor}
        prevButtonDesign={buttonDesign}
        prevButtonIcon={prevButtonIcon}
        prevButtonText={null}
        renderLinks
        showEdges
        showPages={showPages}
        shape={moleculePaginationShapes.CIRCULAR}
        size={moleculePaginationSizes.SMALL}
        totalPages={totalPages}
        urlPattern={urlPattern}
        ariaLabel={i18n.t('COMMON.PAGINATION.ARIA_LABEL')}
        prevLinkAriaLabel={i18n.t('COMMON.PAGINATION.PREV_LINK')}
        nextLinkAriaLabel={i18n.t('COMMON.PAGINATION.NEXT_LINK')}
        pagePrefixAriaLabel={i18n.t('COMMON.PAGINATION.PAGE_PREFIX')}
      />
    </div>
  )
}

ListPagination.displayName = 'ListPagination'

ListPagination.propTypes = {
  createUrl: PropTypes.func,
  currentPage: PropTypes.number,
  linkFactory: PropTypes.func,
  onClick: PropTypes.func,
  showPages: PropTypes.number,
  totalPages: PropTypes.number,
  urlPattern: PropTypes.string
}

export {DEFAULT_PAGE_NUMBER_PLACEHOLDER as pageNumberPlaceholder}

export default ListPagination
